import { GridController, gridTpl } from '../../../../../common/grid/grid.controller';
import { IDS } from '../pnp-approval.constants';
import { getDocument } from '../pnp-approval.actions';
import { getDocumentCategories } from '../../pnp-docs.actions';
import watch from 'redux-watch';
import moment from 'moment/moment';
import {DATE_FORMAT} from '../../../../../common/utils/util.constants';

class pnpApprovalGridController extends GridController {
    /* @ngInject */
    constructor($ngRedux, $state, NavigationService, $filter, $mdDialog, $scope, $rootScope, AuthService) {
        super($ngRedux, $state, NavigationService, $filter, $mdDialog);
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        this.$filter = $filter;
        this.AuthService = AuthService;
    }

    $onInit() {
        this.module = 'policies';
        this.identifier = IDS.pnpDocumentApprovalGrid;
        this.filterTemplate = './pnp-approval-grid-filter.html';

        this.columns = [
            { title: '#', mapper: null },
            { title: 'Head Office', mapper: 'headOffice' },
            { title: 'Site Location', mapper: 'siteLocation' },
            { title: 'Department', mapper: 'department' },
            { title: 'Document Number', mapper: 'docNum' },
            { title: 'Version', mapper: 'version' },
            { title: 'Title', mapper: 'title' },
            { title: 'Document Category', mapper: 'documentCategory' },
            { title: 'Document Type', mapper: 'documentType' },
            { title: 'Created Date', mapper: 'createdDate' },
            { title: 'Approval Due Date', mapper: 'approvalDueDate' },
            { title: 'Document Due Date', mapper: 'documentDueDate' },
            { title: 'Author', mapper: 'author' },
            { title: 'Task Type', mapper: 'reviewType' },
            { title: 'Status', mapper: 'docStatus' },
            { title: 'LinkedToAccreditation', mapper: 'linkWithAccreditation'}
        ];

        this.unsubscribe = this.$ngRedux.connect(
            this.mapState().bind(this),
            { getDocument, getDocumentCategories }
        )(this);
        this.filter.identifier = this.identifier;
        this.dataAction = this.getDocument;
        this.exportService = this.getDocument;

        this.buttons = [{
            class: 'btnGridAction',
            label: (item) => {
                return item.reviewType === 'Document Review Task' ? 'Review' : 'Approve';
            },
            callback: event => {
                this.onSelect(event)
            }
        }, {
            class: 'btnGridAction',
            label: 'Download',
            callback: event => {
                this.onDownload(event)
            },
            filter: item => {
                return item.downloadAllowed ? item.path : null;
            }
        }];

        const watchLocation = watch(this.$ngRedux.getState, 'policies.pnpDocumentApprovalGrid.filter.location');
        this.unsubscribeLocation = this.$ngRedux.subscribe(watchLocation((location) => {
            this.getDocumentCategories(location);
        }));

        this.init();
        this.buttonsDefault = this.buttons.concat();
    }


    $onDestroy() {
        this.destroy();
    }
}


pnpApprovalGridController.$inject = ['$ngRedux', '$state', 'NavigationService', '$filter', '$mdDialog', '$scope', '$rootScope'];

export const pnpApprovalGrid = {
    bindings: {
        title: '@',
        onSelect: '&',
        onDownload: '&',
        onReset: '&'
    },
    controller: pnpApprovalGridController,
    ...gridTpl
}
